import React from 'react';
import Button from '../../atoms/button';
import I10n from '../../features/i10n';
import styled from 'styled-components';
import InformationIcon from '../../atoms/information-icon';
import MsxIcons from '../../features/msx-icons';
import SoftwareLicenceQuantityEditor from './software_licence_quantity_editor';
import ProductLink from '../product_link';
import DropdownMenu from '../dropdown_menu';
import ProductInformationCache from '../../persistence/description-cache';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../color-constants';
import { LICENSE_MODELS } from '../../constants';

const Wrapper = styled.div`
  margin-top: 20px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-bottom: 10px;
  @media (max-width: 800px) {
    margin-left: 0px;
  }
`;

const Title = styled.span`
  font-size: 18px;
  display: flex;
  margin: 0px;
  margin-right: 10px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  margin-left: 30px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  @media (max-width: 800px) {
    margin-left: 0px;
  }
`;

const Image = styled.img`
  height: 120px;
  object-fit: contain;
  margin-top: -12px;
  display: none;

  @media (max-width: 800px) {
    height: 80px;
    margin-top: -6px;
  }
`;

const ContentContainer = styled.div`
  display:flex;
  flex-direction:column;
  margin-left: 10px;
  margin-bottom: 10px;
`;

const LicenceName = styled.span`
  font-weight: bold;
`;

const LicenceDescription = styled.span`
  margin-top: 10px;
  margin-bottom: 20px;
`;

const PackageContent = styled.div`
  box-sizing: border-box;
  border: 0.5px solid rgba(160, 164, 168, 0.4);
  box-shadow: 0px 0px 4px rgba(98, 100, 105, 0.2);
  border-radius: 8px;
  margin-top: 5px;
  margin-left: 10px;
  margin-bottom: 10px;
  width: 35%;
  legend {
    font-size: 12px;
    text-align: center;
    color: white;
    background-color: #A0A4A8;
    padding: 5px;
    width: fit-content;
    margin: auto;
    margin-bottom: 10px;
    border-radius: 0px 0px 8px 8px;
  }
  @media (max-width: 800px) {
    margin-top: 0px;
    margin-left: 0px;
    width: 100%;
    border-radius: 8px;
  }
`;

const PackageItems = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobilePackageItems = styled.div`
  display: none;
  flex-direction: column;
  font-size: 14px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const PackageItemsRow = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0px;
  box-sizing: border-box;
`;

const PackageIcon = styled.div`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const PackageItemContent = styled.div`
  margin-left: 10px;
`;

const LicenceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px;
  padding: 10px;
  align-items: center;
  background: #F7F7F7;
  border-left: 4px solid ${SECONDARY_COLOR};
  border-left: 4px solid var(--se-primary, ${SECONDARY_COLOR});

  @media (max-width: 800px) {
    align-items: unset;
    flex-direction: column;
    flex-wrap: unset;
  }
`;

const SelectedLicencesHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SelectedLicencesLabel = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #626469;
  margin-right: 10px;
`;

const SelectedLicencesLine = styled.div`
  display: flex;
  flex: 1 1 0px;
  border-bottom: 1px solid #626469;
`;

const LicenceLinkWrapper = styled.div`
  font-weight: 700;
  font-size: 15px;
  margin-right: 20px;
`;

const LicenceLinkAndDescriptionWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ProductDescription = styled.span`
  font-weight: 400;
  font-size: 15px;
  color: #626469;
  @media (max-width: 800px) {
    margin-top: 10px;
  }
`;

const DeleteButton = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  border: 1px solid #ccc;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  border-color: ${PRIMARY_COLOR};
  border-color: var(--se-secondary, ${PRIMARY_COLOR});
  background-color: white;
  border-radius: 4px;
  margin-inline-end: 10px;
  cursor: pointer;
  ${props => props.disabled ? 'opacity: 0.5; pointer-events: none;' : ''}
`;

const QuantityButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 800px) {
    flex: 1 1 0px;
    margin-top: 10px;
 }
`;

const InformationRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 800px) {
    flex-direction: column;
    flex-wrap: unset;
  }
`;

const ArrowCircle = styled.div`
  box-sizing: content-box;
  border: 1px solid black;
  border-radius: 50%;
  margin-left: 10px;
  user-select: none;
  overflow: hidden;
  width: 18px;
  height: 18px;
`;

// CSS hack to center the small arrow (which has natural untouchable padding).
const ArrowWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  width: 18px;
  height: 18px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PackageItem = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex: 1 1 0px;
  width: 50%;
  align-items: center;
  padding: 0px 15px 15px 15px;
  ${props => props.showRightBorder ? `border-right: 2px solid rgba(98, 100, 105, 0.2);`: ``}
`;

const AddLicenceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 0px;
  padding: 20px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  cursor: pointer;

  background-color: #FAFAFA;
  ${props => props.disabled ? `opacity: 0.5;pointer-events: none;` : ''}
`;

const AddLicenceLabel = styled.span`
  margin-left: 10px;
`;

const ImageAndContentWrapper = styled.div`
  display: flex;
  flex: 4 1 0px;
`;

const AddLicenceButtonWrapper = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileAddLicenceButtonWrapper = styled.div`
  display : none;
  @media (max-width: 800px) {
    display: block;
  }
`;

const InformationIconWrapper = styled.div`
  cursor: pointer;
`;

const AdditionalInformationWrapper = styled.div`
  padding: 10px;
  min-width: 200px;
`;

const AdditionalInformationHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #0F0F0F;
  margin-bottom: 10px;
`;

const AdditionalInformationTitle = styled.div`
  font-weight: 700;
  margin-left: 10px;
`;

const AdditionnalInformationBody = styled.span`
`;

class LicenceType extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
    };
  }

  toggleSelectedLicenceDropdown = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  renderPackageItem = (packageItem, showRightBorder) => {
    return(
      <PackageItem showRightBorder={showRightBorder}>
        <PackageIcon>
          <MsxIcons name="selected" size="x-small" ></MsxIcons>
        </PackageIcon>
        <PackageItemContent>
          {I10n.getOrDefault(`screen.licence_selector.package_item.${packageItem.key}`, packageItem.name)}
        </PackageItemContent>
      </PackageItem>
    );
  }

  renderPackageItems = (packageItems) => {
    return (
      <>
        <PackageItems>
          {packageItems.slice(0, 3).map((packageItem, arrayIdx) => {
            return (
              <PackageItemsRow key={arrayIdx}>
                {this.renderPackageItem(packageItem, packageItems.length > 3)}
                {packageItems.length > 3 && (packageItems[arrayIdx + 3] ? this.renderPackageItem(packageItems[arrayIdx + 3], false): <PackageItem></PackageItem>)}
              </PackageItemsRow>
            );
          })}
        </PackageItems>
        <MobilePackageItems>
          {packageItems.slice(0, 6).map((packageItem, arrayIdx) => {
            return (
              <PackageItemsRow key={arrayIdx}>
                {this.renderPackageItem(packageItem, false)}
              </PackageItemsRow>
            );
          })}
        </MobilePackageItems>
      </>
    );
  }

  filterScopedReferencesWithLicenseLevel = (licenceType) => {
    return licenceType.scopedReferences.filter(licence => {
      if (this.props.licenseLevel != null) {
        return licence.licenseLevel == null || licence.licenseLevel === this.props.licenseLevel;
      }

      return true;
    });
  }

  /**
   * Check if the user can add the licences for a licence type.
   * If all licences are not scoped, the result should be false.
   *
   * @param {*} licenceType
   * @param {*} licencesToShow
   * @returns
   */
  canAddLicences = (licenceType, licencesToShow) => {
    const licensesToExamine = this.filterScopedReferencesWithLicenseLevel(licenceType);
    return licensesToExamine.length !== licensesToExamine.filter(baseLicence => licencesToShow.map(l => l.id).includes(baseLicence.id)).length;
  }

  renderAddSoftwareLicenceButton = (licenceType, licencesToShow, isSaving, onAddSoftwareLicencesRequested) => {
    return (
      <>
        {licencesToShow.length === 0 && (
          <Button
            importance="emphasized"
            icon-name="plus-circle"
            primary
            disabled={isSaving || !this.canAddLicences(licenceType, licencesToShow)}
            onClick={event => {
              onAddSoftwareLicencesRequested(licenceType);
            }}
          >
            {I10n.get('screen.licence_selector.add_licence')}
          </Button>
        )}
      </>
    );
  }

  renderAdditionalInformationToggle = (licenceType) => {
    return (<InformationIconWrapper><InformationIcon size="small" title={licenceType.additionalInformation}/></InformationIconWrapper>);
  }

  renderAdditionalInformationContent = (licenceType) => {
    return <AdditionalInformationWrapper>
      <AdditionalInformationHeader>
        <InformationIcon></InformationIcon>
        <AdditionalInformationTitle>{I10n.getOrDefault(`screen.licence_selector.title.${licenceType.key}`, licenceType.title)}</AdditionalInformationTitle>
      </AdditionalInformationHeader>
      <AdditionnalInformationBody>{I10n.getOrDefault(`screen.licence_selector.additonalinformation.${licenceType.key}`, licenceType.additionalInformation)}</AdditionnalInformationBody>
    </AdditionalInformationWrapper>;
  }

  render() {
    const {
      licenceType,
      licenceGroup,
      isSaving,
      onAddSoftwareLicencesRequested,
      softwareLicences
    } = this.props;

    const disableActions = this.props.configurationSaver.isSaving;

    const licencesToShow = softwareLicences
      .filter((licence) => licence.licenceGroup === licenceGroup.key && licence.licenceCategory === licenceType.key);

    return (
        <Wrapper>
          <TitleWrapper>
            <Title>
              {I10n.getOrDefault(`screen.licence_selector.title.${licenceType.key}`, licenceType.title)}
            </Title>

            {licenceType.additionalInformation && <DropdownMenu
              data-clickable
              toggleElement={this.renderAdditionalInformationToggle(licenceType)}
              containerElement={this.renderAdditionalInformationContent(licenceType)}
              allowTop={true}
            >
            </DropdownMenu>}
          </TitleWrapper>
          <Card>
            <InformationRow>
              <ImageAndContentWrapper>
                <Image src={licenceType.imageURL}/>
                <ContentContainer>
                  <LicenceName>{I10n.getOrDefault(`screen.licence_selector.licence_name.${licenceType.key}`, licenceType.licenceName)}</LicenceName>
                  <LicenceDescription>{I10n.getOrDefault(`screen.licence_selector.description.${licenceType.key}`, licenceType.description)}</LicenceDescription>
                  <AddLicenceButtonWrapper>
                    {this.renderAddSoftwareLicenceButton(licenceType, licencesToShow, isSaving, onAddSoftwareLicencesRequested)}
                  </AddLicenceButtonWrapper>
                </ContentContainer>
              </ImageAndContentWrapper>
              {licenceType.packageContent && <PackageContent>
                <legend>
                  {I10n.getOrDefault(`screen.licence_selector.package_content.name.${licenceType.packageContent.key}`, licenceType.packageContent.name)}</legend>
                {this.renderPackageItems(licenceType.packageContent.packageItems)}
              </PackageContent>}
            </InformationRow>
            <MobileAddLicenceButtonWrapper>
              {this.renderAddSoftwareLicenceButton(licenceType, licencesToShow, isSaving, onAddSoftwareLicencesRequested)}
            </MobileAddLicenceButtonWrapper>
            {licencesToShow.length > 0 && (
                <>
                  <SelectedLicencesHeader onClick={this.toggleSelectedLicenceDropdown}>
                    <SelectedLicencesLabel>
                      {I10n.get('screen.licence_selector.selected_licences')}
                    </SelectedLicencesLabel>
                    <SelectedLicencesLine></SelectedLicencesLine>
                    <ArrowCircle>
                      <ArrowWrapper isOpen={this.state.isOpen}>
                        <MsxIcons name="down-arrow" size="nano"></MsxIcons>
                      </ArrowWrapper>
                    </ArrowCircle>
                  </SelectedLicencesHeader>
                  {this.state.isOpen && (
                    <>
                      {licencesToShow.map((licence) => {
                        return (
                          <LicenceWrapper key={licence.id + licence.licenceCategory + licence.licenceGroup}>
                            <LicenceLinkAndDescriptionWrapper>
                              <LicenceLinkWrapper>
                                <ProductLink reference={licence.id} disabled={LICENSE_MODELS.SUBSCRIPTION === this.props.licenseModel}></ProductLink>
                              </LicenceLinkWrapper>
                              <ProductDescription>{ProductInformationCache.getDescription(licence.id) || licence.description}</ProductDescription>
                            </LicenceLinkAndDescriptionWrapper>
                            <QuantityButtons>
                              <SoftwareLicenceQuantityEditor
                                disabled={disableActions}
                                key={licence.quantity}
                                ref={this.quantityInputRef}
                                quantity={licence.quantity}
                                licence={licence}
                                references={licence.references}
                                configurationSaver={this.props.configurationSaver}
                                setSoftwareLicenceQuantity={this.props.setSoftwareLicenceQuantity}
                                removeSoftwareLicence={this.props.removeSoftwareLicence}
                              />
                              <DeleteButton
                                disabled={disableActions}
                                onClick={() => {
                                  if (!disableActions) {
                                    this.props.removeSoftwareLicence(licence);
                                  }
                                }}
                              >
                                <MsxIcons name="delete" size="small" />
                              </DeleteButton>
                            </QuantityButtons>
                          </LicenceWrapper>
                        );
                      })}
                    </>)}
                  <AddLicenceWrapper onClick={() => { onAddSoftwareLicencesRequested(licenceType); }} disabled={isSaving || !this.canAddLicences(licenceType, licencesToShow)}>
                    <MsxIcons name="add"></MsxIcons>
                    <AddLicenceLabel>{I10n.get('screen.licence_selector.add_other_licence')}</AddLicenceLabel>
                  </AddLicenceWrapper>
                </>
              )}
          </Card>
        </Wrapper>
    );
  }
}

export default LicenceType;
